import { render } from "./PayslipAttendanceBreakdownTable.vue?vue&type=template&id=17f5d217&scoped=true"
import script from "./PayslipAttendanceBreakdownTable.vue?vue&type=script&lang=js"
export * from "./PayslipAttendanceBreakdownTable.vue?vue&type=script&lang=js"

import "./PayslipAttendanceBreakdownTable.vue?vue&type=style&index=0&id=17f5d217&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f5d217"]])

export default __exports__